<script lang="ts">
import { AppLinkComponent } from "./app-link.ts";
export default AppLinkComponent;
</script>
<template>
    <a v-if="externalLink" :href="externalLink" v-bind="$attrs">
        <slot>
            {{ link.title }}
        </slot>
    </a>
    <router-link v-if="internalLink" :to="internalLink" v-bind="$attrs">
        <slot>
            {{ link.title }}
        </slot>
    </router-link>
</template>
